import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { Utensils, Sandwich, Coffee, IceCream } from 'lucide-react';

export const MenusExtras = () => {
  const menus = [
    {
      name: 'MENU NUGGETS MAISON',
      price: '13,50€',
      description: 'Une portion de nuggets maison (nature, curry ou mix), une frite maison, une boisson soft 33cl',
      icon: Utensils,
    },
    {
      name: 'MENU LOUSTIC',
      price: '10,50€',
      description: 'Une pizza loustic au choix (Reine, margherita ou 4 fromages), un capri-sun orange ou multifruits, un dessert et un bonbon',
      icon: Coffee,
      tag: 'Enfant',
    },
    {
      name: 'MENU ENFANT',
      price: '10,50€',
      description: 'Un hamburger au choix (bœuf ou poulet pané maison), cheddar et ketchup ou 3 nuggets maison, une petite frite, un dessert, un capri-sun au choix, un bonbon',
      icon: IceCream,
      tag: 'Enfant',
    },
  ];

  const barquettes = [
    {
      name: 'LA PIG',
      price: '14,50€',
      description: 'Effiloché maison d\'épaule de porc breton cuite à basse température pendant 12h, mariné selon l\'envie du chef, sauce cheddar maison, frites maison et oignons frits',
    },
    {
      name: 'LA CHICKEN',
      price: '14,50€',
      description: 'Morceaux de nuggets maison nature ou curry, sauce cheddar maison, frites maison, oignons frits et sauce au choix',
    },
    {
      name: 'BEEF AND CHEESE',
      price: '14,50€',
      description: 'Frites maison, steak haché, sauce cheddar maison, oignons frits et sauce au choix',
    },
  ];

  const wraps = [
    {
      name: 'WRAP BŒUF',
      price: '9,00€',
      description: 'Galette, salade, tomates, sauce burger, oignons frits, double cheddar, double chorizo et steak 85gr',
    },
    {
      name: 'WRAP POULET',
      price: '9,00€',
      description: 'Galette, salade, tomates, sauce burger, oignons frits, double cheddar, double chorizo et nuggets nature ou curry',
    },
    {
      name: 'WRAP VG',
      price: '9,00€',
      description: 'Galette, salade, tomates, sauce burger, oignons frits, galette de pomme de terre et cheddar (chèvre +1€)',
      tag: 'Végétarien',
    },
  ];

  const sides = [
    { name: 'PORTION DE FRITES MAISON', price: '3,50€' },
    { name: 'FRITES ENFANT', price: '2,50€' },
    { name: 'FRITES SAUCE CHEDDAR', price: '6,50€', note: '(+3€ en formule)' },
    { name: 'NUGGETS MAISON - 3 pièces', price: '4,50€' },
    { name: 'NUGGETS MAISON - 6 pièces', price: '9,00€' },
    { name: 'NUGGETS MAISON - 9 pièces', price: '13,50€' },
    { name: 'NUGGETS MAISON - 12 pièces', price: '18,00€' },
  ];

  const supplements = [
    { name: 'STEAK 120gr', price: '4,00€' },
    { name: 'POULET PANÉ MAISON', price: '4,00€' },
    { name: 'GALETTE DE POMME DE TERRE', price: '2,50€' },
    { name: 'OIGNONS FRITS', price: '1,50€' },
    { name: 'FROMAGE DOUBLÉ (dans les burgers)', price: '2,50€' },
    { name: 'POT DE SAUCE', price: '2,00€', note: '(Maison : mayonnaise, aïoli, moutarde à l\'ancienne, ketchup, sauce burger du mois, mayonnaise au whisky | Autres : burger, bbq, poivre, curry, algérienne, samouraï)' },
  ];

  const drinks = [
    { name: 'CANETTE SOFT 33cl', price: '2,00€' },
    { name: 'COCA COLA, FANTA, ICE TEA 1L25', price: '3,50€' },
    { name: 'CIDRE BRUT ou DOUX', price: '3,50€' },
    { name: 'BIÈRE SKLENT (Blonde, IPA, DIPA, Neipa, Rousse, Triple, Stout, Hazy, Blanche)', price: 'Sur place' },
    { name: 'BIÈRE SKLENT 75CL (Blonde, IPA, Neipa)', price: 'Sur place' },
    { name: 'BOUTEILLE DE VIN 75cl (Rouge, rosé ou blanc)', price: '16,00€' },
  ];

  const desserts = [
    { name: 'Donuts', price: '2,50€' },
    { name: 'Muffin', price: '3,00€' },
    { name: 'Dessert maison', price: '3,50€' },
  ];

  return (
    <section className="py-16 sm:py-24 bg-gradient-subtle">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Menus Section */}
        <div className="mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-foreground mb-8 text-center">
            Nos Menus
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {menus.map((menu, index) => {
              const Icon = menu.icon;
              return (
                <Card key={index} className="border-border shadow-soft hover:shadow-medium transition-all duration-300 bg-card">
                  <CardHeader>
                    <div className="flex items-start justify-between mb-2">
                      <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                        <Icon className="w-6 h-6 text-primary" />
                      </div>
                      {menu.tag && (
                        <Badge variant="outline" className="bg-secondary/20 text-secondary-foreground border-secondary/30">
                          {menu.tag}
                        </Badge>
                      )}
                    </div>
                    <CardTitle className="text-xl font-semibold text-foreground">
                      {menu.name}
                    </CardTitle>
                    <div className="text-2xl font-bold text-primary mt-2">{menu.price}</div>
                  </CardHeader>
                  <CardContent>
                    <p className="text-sm text-muted-foreground leading-relaxed">{menu.description}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>

        {/* Barquettes & Wraps */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {/* Barquettes */}
          <div>
            <h3 className="text-2xl sm:text-3xl font-bold text-foreground mb-6">
              Nos Barquettes
            </h3>
            <div className="space-y-4">
              {barquettes.map((item, index) => (
                <Card key={index} className="border-border shadow-soft bg-card">
                  <CardContent className="p-6">
                    <div className="flex items-start justify-between mb-2">
                      <h4 className="text-lg font-semibold text-foreground">{item.name}</h4>
                      <span className="text-lg font-bold text-primary whitespace-nowrap ml-4">{item.price}</span>
                    </div>
                    <p className="text-sm text-muted-foreground leading-relaxed">{item.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>

          {/* Wraps */}
          <div>
            <h3 className="text-2xl sm:text-3xl font-bold text-foreground mb-6">
              Nos Wraps
            </h3>
            <div className="space-y-4">
              {wraps.map((item, index) => (
                <Card key={index} className="border-border shadow-soft bg-card">
                  <CardContent className="p-6">
                    <div className="flex items-start justify-between mb-2">
                      <div className="flex items-center gap-2">
                        <h4 className="text-lg font-semibold text-foreground">{item.name}</h4>
                        {item.tag && (
                          <Badge variant="outline" className="bg-green-500/20 text-green-700 border-green-500/30 text-xs">
                            {item.tag}
                          </Badge>
                        )}
                      </div>
                      <span className="text-lg font-bold text-primary whitespace-nowrap ml-4">{item.price}</span>
                    </div>
                    <p className="text-sm text-muted-foreground leading-relaxed">{item.description}</p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>

        {/* Sides, Supplements, Drinks & Desserts */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Sides */}
          <div>
            <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-4">
              Nos Petits Plus
            </h3>
            <Card className="border-border shadow-soft bg-card">
              <CardContent className="p-6">
                <div className="space-y-3">
                  {sides.map((item, index) => (
                    <div key={index} className="flex items-start justify-between pb-3 border-b border-border last:border-0 last:pb-0">
                      <div className="pr-2">
                        <span className="text-sm text-foreground">{item.name}</span>
                        {item.note && <span className="text-xs text-muted-foreground ml-1">{item.note}</span>}
                      </div>
                      <span className="text-sm font-semibold text-primary whitespace-nowrap">{item.price}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Supplements */}
          <div>
            <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-4">
              Suppléments
            </h3>
            <Card className="border-border shadow-soft bg-card">
              <CardContent className="p-6">
                <div className="space-y-3">
                  {supplements.map((item, index) => (
                    <div key={index} className="flex items-start justify-between pb-3 border-b border-border last:border-0 last:pb-0">
                      <div className="pr-2 flex-1">
                        <span className="text-sm text-foreground">{item.name}</span>
                        {item.note && <p className="text-xs text-muted-foreground mt-1">{item.note}</p>}
                      </div>
                      <span className="text-sm font-semibold text-primary whitespace-nowrap">{item.price}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Drinks */}
          <div>
            <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-4">
              Boissons
            </h3>
            <Card className="border-border shadow-soft bg-card">
              <CardContent className="p-6">
                <div className="space-y-3">
                  {drinks.map((item, index) => (
                    <div key={index} className="flex items-start justify-between pb-3 border-b border-border last:border-0 last:pb-0">
                      <span className="text-sm text-foreground pr-2">{item.name}</span>
                      <span className="text-sm font-semibold text-primary whitespace-nowrap">{item.price}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Desserts */}
          <div>
            <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-4">
              Desserts
            </h3>
            <Card className="border-border shadow-soft bg-card">
              <CardContent className="p-6">
                <div className="space-y-3">
                  {desserts.map((item, index) => (
                    <div key={index} className="flex items-start justify-between pb-3 border-b border-border last:border-0 last:pb-0">
                      <span className="text-sm text-foreground pr-2">{item.name}</span>
                      <span className="text-sm font-semibold text-primary whitespace-nowrap">{item.price}</span>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* Student Offer Banner */}
        <div className="mt-12 p-6 sm:p-8 bg-primary/10 border-2 border-primary/30 rounded-lg text-center max-w-2xl mx-auto">
          <div className="text-3xl sm:text-4xl font-bold text-primary mb-2">
            -10% ÉTUDIANTS
          </div>
          <p className="text-sm text-foreground">
            Sur présentation de la carte étudiant de l'année en cours
          </p>
        </div>
      </div>
    </section>
  );
};

export default MenusExtras;